
// 给每个a链接新添加一个class commercial_link_hyt，用于此次append置顶入口布点dom时判断当前页面是否已经有了置顶布点的dom，如果已经有了则不再append，否则则append


var issueDom = {
			"26":  `<div class="commercial_vip">
						<p class="commercial_empty"></p><h3 class="commercial_vip_title">头条</h3><p class="commercial_mqtt_tips">职位列表顶部展示，稀缺高流量展位dataText</p>
						<span data-href="dataLink" class="commercial_vip_top commercial_link commercial_link_zl">isTypeText</span>
					</div>`
		}

export default function(commonType,isType,link,text){
    var type = ",25,".indexOf(','+commonType+',') > -1?26:commonType;
    var manege = isType ? '管理': '新建';
	return issueDom[type].replace("dataLink",link).replace("dataText",text).replace("isTypeText",manege);
}
